/**
 * crypto.randomUUID() only exists in secure contexts (HTTPS or localhost).
 * Accessing the app over plain HTTP via a LAN IP (e.g. npm run dev --host)
 * is not a secure context, so the function is undefined there. Fall back
 * to a non-cryptographic UUID-shaped id in that case.
 */
export function generateUUID(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
